import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1FontXsProps extends ITextBoxProps {
  bold?: boolean
}

export const TextBoxMaxLine1FontXs = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.FontXs,
  alignment = TextAligning.Center,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1FontXsProps): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      maxLines={maxLines}
      {...rest}
    />
  )
}
